// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/.pnpm/css-loader@7.1.3_webpack@5.105.2_esbuild@0.28.1_postcss@8.5.23_/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/.pnpm/css-loader@7.1.3_webpack@5.105.2_esbuild@0.28.1_postcss@8.5.23_/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Work+Sans:wght@500;600&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.profile-page {
  padding: 20px 0 32px;
}

.profile-shell {
  max-width: 720px;
  margin: 0 auto;
}

.profile-card {
  background: #ffffff;
  border-radius: 14px;
  box-shadow: 0 12px 36px rgba(0, 0, 0, 0.08);
  padding: 24px;
  border: 1px solid rgba(0, 0, 0, 0.05);
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.profile-header {
  display: flex;
  align-items: center;
  gap: 14px;
}

.profile-icon {
  width: 48px;
  height: 48px;
  border-radius: 14px;
  background: rgba(107, 64, 146, 0.12);
  color: var(--e-global-color-primary);
  display: grid;
  place-items: center;
}

.eyebrow {
  margin: 0;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  font-size: 12px;
  color: #6c757d;
}

.profile-title {
  margin: 0;
  font-size: 26px;
  font-family: "Work Sans", Arial, sans-serif;
}

.profile-subtitle {
  margin: 0;
  color: #4a5568;
}

.profile-body {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.info-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  padding: 12px 14px;
  border: 1px solid #e3e7ef;
  border-radius: 12px;
  background: #f8f9fb;
}

.stat-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

.stat {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 12px 14px;
  border: 1px solid #e3e7ef;
  border-radius: 12px;
  background: #f8f9fb;
}

.stat-value {
  font-size: 24px;
  line-height: 1.2;
  color: #1f2933;
}

.label {
  color: #6c757d;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  font-weight: 700;
  font-size: 12px;
}

.value {
  font-weight: 600;
  color: #1f2937;
}

.divider {
  border-top: 1px solid rgba(0, 0, 0, 0.06);
  margin: 6px 0;
}

.danger-zone {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.danger-hint {
  margin: 0;
  color: #6b7280;
  max-width: 520px;
}

.empty-state {
  display: grid;
  place-items: center;
  gap: 8px;
  text-align: center;
  padding: 12px 0 4px;
  color: #4a5568;
}

.empty-icon {
  width: 48px;
  height: 48px;
  border-radius: 14px;
  background: rgba(107, 64, 146, 0.12);
  color: var(--e-global-color-primary);
  display: grid;
  place-items: center;
}

.empty-text {
  margin: 0;
}

@media (max-width: 576px) {
  .profile-card {
    padding: 18px;
  }
  .profile-title {
    font-size: 22px;
  }
  .info-row {
    flex-direction: column;
    align-items: flex-start;
  }
}`, "",{"version":3,"sources":["webpack://./projects/public/src/app/components/profile-page/profile-page.component.scss"],"names":[],"mappings":"AAEA;EACE,oBAAA;AAAF;;AAGA;EACE,gBAAA;EACA,cAAA;AAAF;;AAGA;EACE,mBAAA;EACA,mBAAA;EACA,2CAAA;EACA,aAAA;EACA,qCAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAAF;;AAGA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAAF;;AAGA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,oCAAA;EACA,oCAAA;EACA,aAAA;EACA,mBAAA;AAAF;;AAGA;EACE,SAAA;EACA,yBAAA;EACA,sBAAA;EACA,eAAA;EACA,cAAA;AAAF;;AAGA;EACE,SAAA;EACA,eAAA;EACA,2CAAA;AAAF;;AAGA;EACE,SAAA;EACA,cAAA;AAAF;;AAGA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAAF;;AAGA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;AAAF;;AAGA;EACE,aAAA;EACA,8BAAA;EACA,SAAA;AAAF;;AAGA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;AAAF;;AAGA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AAAF;;AAGA;EACE,cAAA;EACA,yBAAA;EACA,sBAAA;EACA,gBAAA;EACA,eAAA;AAAF;;AAGA;EACE,gBAAA;EACA,cAAA;AAAF;;AAGA;EACE,yCAAA;EACA,aAAA;AAAF;;AAGA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;AAAF;;AAGA;EACE,SAAA;EACA,cAAA;EACA,gBAAA;AAAF;;AAGA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;AAAF;;AAGA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,oCAAA;EACA,oCAAA;EACA,aAAA;EACA,mBAAA;AAAF;;AAGA;EACE,SAAA;AAAF;;AAGA;EACE;IACE,aAAA;EAAF;EAGA;IACE,eAAA;EADF;EAIA;IACE,sBAAA;IACA,uBAAA;EAFF;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Work+Sans:wght@500;600&display=swap');\n\n.profile-page {\n  padding: 20px 0 32px;\n}\n\n.profile-shell {\n  max-width: 720px;\n  margin: 0 auto;\n}\n\n.profile-card {\n  background: #ffffff;\n  border-radius: 14px;\n  box-shadow: 0 12px 36px rgba(0, 0, 0, 0.08);\n  padding: 24px;\n  border: 1px solid rgba(0, 0, 0, 0.05);\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.profile-header {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n}\n\n.profile-icon {\n  width: 48px;\n  height: 48px;\n  border-radius: 14px;\n  background: rgba(107, 64, 146, 0.12);\n  color: var(--e-global-color-primary);\n  display: grid;\n  place-items: center;\n}\n\n.eyebrow {\n  margin: 0;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  font-size: 12px;\n  color: #6c757d;\n}\n\n.profile-title {\n  margin: 0;\n  font-size: 26px;\n  font-family: 'Work Sans', Arial, sans-serif;\n}\n\n.profile-subtitle {\n  margin: 0;\n  color: #4a5568;\n}\n\n.profile-body {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.info-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 14px;\n  border: 1px solid #e3e7ef;\n  border-radius: 12px;\n  background: #f8f9fb;\n}\n\n.stat-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n}\n\n.stat {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  padding: 12px 14px;\n  border: 1px solid #e3e7ef;\n  border-radius: 12px;\n  background: #f8f9fb;\n}\n\n.stat-value {\n  font-size: 24px;\n  line-height: 1.2;\n  color: #1f2933;\n}\n\n.label {\n  color: #6c757d;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  font-weight: 700;\n  font-size: 12px;\n}\n\n.value {\n  font-weight: 600;\n  color: #1f2937;\n}\n\n.divider {\n  border-top: 1px solid rgba(0, 0, 0, 0.06);\n  margin: 6px 0;\n}\n\n.danger-zone {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.danger-hint {\n  margin: 0;\n  color: #6b7280;\n  max-width: 520px;\n}\n\n.empty-state {\n  display: grid;\n  place-items: center;\n  gap: 8px;\n  text-align: center;\n  padding: 12px 0 4px;\n  color: #4a5568;\n}\n\n.empty-icon {\n  width: 48px;\n  height: 48px;\n  border-radius: 14px;\n  background: rgba(107, 64, 146, 0.12);\n  color: var(--e-global-color-primary);\n  display: grid;\n  place-items: center;\n}\n\n.empty-text {\n  margin: 0;\n}\n\n@media (max-width: 576px) {\n  .profile-card {\n    padding: 18px;\n  }\n\n  .profile-title {\n    font-size: 22px;\n  }\n\n  .info-row {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
